import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export function KycFooter() {
  return (
    <Stack
      component="footer"
      sx={{
        display: { xs: "flex", lg: "none" },
        alignItems: "center",
        gap: 1,
        mt: "auto",
        pt: 5,
        color: "text.secondary",
      }}
    >
      <Stack direction="row" sx={{ alignItems: "center", gap: 0.75 }}>
        <Typography variant="body3">Powered by</Typography>
        <Box
          component="img"
          src="/logo.svg"
          alt="Trustap"
          sx={{ display: "block", width: 98 }}
        />
      </Stack>
      <Stack direction="row" sx={{ alignItems: "center", gap: 0.75 }}>
        <VerifiedUserIcon sx={{ fontSize: 16 }} />
        <Typography variant="body3">Trust in every transaction</Typography>
      </Stack>
    </Stack>
  );
}
